import { createAction, props } from "@ngrx/store";
import {
  IAMAccountCreateCmd,
  IAMAccountEntity,
  IAMAccountCredentialsDownloadCmd,
  IAMAccountCredentialsDownloadedCmd,
  IAMAccountCredentialsUpdateCmd,
  IAMAccountUpdateCmd,
  IAMAccountDeleteCmd
} from "@youm-front/iam-account/domain";

export const iamAccountCreate = createAction(
  "[IAMAccounts] IAM Account Сreate",
  props<{ iamAccountCreateCmd: IAMAccountCreateCmd }>()
);
export const iamAccountCreateSuccess = createAction(
  "[IAMAccounts] IAM Account Create Success",
  props<{ account: IAMAccountEntity }>()
);
export const iamAccountCreateFailure = createAction(
  "[IAMAccounts] IAM Account Create Failure",
  props<{ error: string }>()
);

export const iamAccountCredentialsUpdate = createAction(
  "[IAMAccounts] IAM Account Credentials Update",
  props<{ iamAccountCredentialsUpdateCmd: IAMAccountCredentialsUpdateCmd }>()
);
export const iamAccountCredentialsUpdateSuccess = createAction(
  "[IAMAccounts] IAM Account Credentials Update Success",
  props<{ account: IAMAccountEntity }>()
);
export const iamAccountCredentialsUpdateFailure = createAction(
  "[IAMAccounts] IAM Account Credentials Update Failure",
  props<{ error: string }>()
);

export const iamAccountCredentialsDownload = createAction(
  "[IAMAccounts] IAM Account Credentials Download",
  props<{
    iamAccountCredentialsDownloadCmd: IAMAccountCredentialsDownloadCmd;
  }>()
);

export const iamAccountCredentialsDownloaded = createAction(
  "[IAMAccounts] IAM Account Credentials Delete",
  props<{
    iamAccountCredentialsDownloadedCmd: IAMAccountCredentialsDownloadedCmd;
  }>()
);

export const iamAccountDelete = createAction(
  "[IAMAccounts] IAM Account Delete",
  props<{ iamAccountDeleteCmd: IAMAccountDeleteCmd }>()
);
export const iamAccountDeleteSuccess = createAction(
  "[IAMAccounts] IAM Account Delete Success",
  props<{ iamAccountDeleteCmd: IAMAccountDeleteCmd }>()
);
export const iamAccountDeleteFailure = createAction(
  "[IAMAccounts] IAM Account Delete Failure",
  props<{ error: string }>()
);

export const iamAccountsList = createAction("[IAMAccounts] IAM Accounts List");
export const iamAccountsListSuccess = createAction(
  "[IAMAccounts] IAM Accounts List Success",
  props<{ accounts: IAMAccountEntity[] }>()
);
export const iamAccountsListFailure = createAction(
  "[IAMAccounts] IAM Accounts List Failure",
  props<{ error: string }>()
);

export const iamAccountUpdate = createAction(
  "[IAMAccounts] IAM Account Update",
  props<{ iamAccountUpdateCmd: IAMAccountUpdateCmd }>()
);
export const iamAccountUpdateSuccess = createAction(
  "[IAMAccounts] IAM Account Update Success",
  props<{ account: IAMAccountEntity }>()
);
export const iamAccountUpdateFailure = createAction(
  "[IAMAccounts] IAM Account Update Failure",
  props<{ error: string }>()
);
